<template>
    <div class="mask">
        <div class="cash-back-prop">
            <img class="bg" src="@/assets/images/activitys/newPlayer/pop/bg.png">
            <div class="cash-back-content">
                <div class="i18n-img">
                    <img class="icon-2" :src="require(`@/assets/images/activitys/newPlayer/pop/${t('activitys.img.11')}`)" />
                    <img class="icon-3" :src="require(`@/assets/images/activitys/newPlayer/pop/${t('activitys.img.12')}`)" />
                </div>
                <div class="items-content">
                    <div class="cash-items">
                        <div class="cash-item" v-for="(item, index) in configArr">
                            <div class="item-content">
                                <div class="item-top-tag">
                                    {{ t(`bouns.${16 + index}`) }}
                                </div>
                                <div class="deposite-text display-column display-y-center">
                                    <span v-if="currentChannel.channel==CHANNEL_CONFIG.ID">
                                        {{ currentChannel.currencyGold + changeMoney(item.chargeAmount) }}
                                    </span>
                                    <span v-else>{{ currentChannel.currencyGold + changeAmount(item.chargeAmount) }}</span>
                                    <div class="deposit-txt">{{ t('common.3') }}</div>
                                </div>
                                <div class="return-div">
                                    <div class="return-text display-x-center display-y-center">
                                        <img src="@/assets/images/activitys/newPlayer/cash_item_treasure.png" />
                                        <div class="return-num">
                                            <div>{{ t('bouns.3') }}</div>
                                            <div class="return-amount">{{ currentChannel.currencyGold + changeMoney(item.returnAmount) }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail" @click="()=> {
                    store.state.isShowCashBackProp = false;
                    router.push('/cashBack');
                }">
                    <div>{{ "Details" }}</div>
                    <img src="@/assets/images/activitys/newPlayer/pop/cash_tip_arrow.png" />
                </div>
                <div class="confirm" @click="()=> {
                    store.state.isShowCashBackProp = false;
                    router.push('/deposit');
                }">
                    {{ "Depositar Agora" }}
                </div>
            </div>
            <img class="btn-close" src="@/assets/images/common/btn_close.png" @click="store.state.isShowCashBackProp = false" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { getChargeRebateInfo } from '@/api/v4';
import { currentChannel } from '@/config/config';
import { CHANNEL_CONFIG } from '@/config/constConfig';
import { changeAmount, changeMoney } from '@/utils/currencyUtils';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

    let store = useStore();
    let router = useRouter();
    let { t } = useI18n();

    let configArr = ref<any[]>([]);

    onMounted(() => {
        initData();
    })

    function initData() {
        getChargeRebateInfo({}).then((res: any) => {
            if (res.data.success) {
                let result = res.data.data;
                configArr.value = result.web4ChargeRebateConfigs;
            }
        });
    }
</script>

<style lang="less" scoped>
    .mask{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .cash-back-prop {
        position: relative;
        .bg {
            width: 369rem;
        }

        .cash-back-content{
            position: absolute;
            top: 30%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            gap: 10rem;
            transform: translateX(-50%);
            left: 50%;

            .i18n-img{
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 5rem;
                .icon-1{
                    width: 303rem;
                }
                .icon-2{
                    width: 269rem;
                }
                .icon-3{
                    width: 266rem;
                }
            }

            .items-content{
                width: 100%;
                .cash-items {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    background: #115697;
                    border-radius: 10rem;
                    padding: 10rem;
                    .cash-item {
                        width: 101rem;
                        height: 133rem;
                        background: linear-gradient(179.92deg, #CDFFF7 0.07%, #5CE6CF 99.93%);
    
                        border-radius: 5rem;
                        position: relative;
                        .item-content {
                            width: 100%;
                            height: 100%;
                            box-sizing: border-box;
                            .item-top-tag{
                                width: 85rem;
                                height: 27rem;
                                border-radius: 5px 0px;
                                background: #FF4C00;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: #FFF;
                                font-family: "Euclid Circular A";
                                font-size: 11rem;
                                font-weight: 700;
                            }
                            .num-icon {
                                width: 23rem;
                            }
                            .deposite-text {
                                font-family: Roboto;
                                color: #171E37;
                                font-weight: 400;
                                font-size: 12rem;
                                margin: 11rem 0 11rem;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                gap: 5rem;
    
                                span {
                                    font-weight: 900;
                                    font-size: 20rem;
                                    line-height: 16rem;
                                }
                                
                                .deposit-txt{
                                    line-height: 12rem;
                                }
                            }
                            .return-div{
                                margin: 0 5rem;
                            }
                            .return-text {
                                // position: absolute;
                                background-color: #49A6FD;
                                padding: 5rem 0;
                                border-radius: 40rem;
                                gap: 3rem;
                                width: 100%;
    
                                font-family: Roboto;
                                font-weight: 400;
                                font-size: 10rem;
                                color: #FFFFFF;
                                display: flex;
                                text-align: center;
    
                                .return-num{
                                    display: flex;
                                    flex-direction: column;
                                }
    
                                .return-amount {
                                    font-size: 13rem;
                                    font-weight: bold;
                                }
    
                                img{
                                    width: 20rem;
                                }
                            }
                        }
                    }
                }
            }


            .detail {
                border-radius: 5rem;
                border: 1px solid #FFFFFF;
                width: 122rem;
                height: 26rem;
                display: flex;
                align-items: center;
                justify-content: center;

                font-family: Roboto;
                font-weight: 700;
                font-size: 16rem;
                color: #FFFFFF;

                gap: 5rem;

                >img{
                    width: 10rem;
                    margin-top: 3rem;
                }
            }
            .confirm {
                width: 237rem;
                height: 36rem;
                background: #FFD645;
                border-radius: 5rem;
                display: flex;
                align-items: center;
                justify-content: center;

                font-family: Roboto;
                font-weight: 500;
                font-size: 14rem;
                text-align: center;
                color: #000000;
            }
        }

        

        .btn-close {
            width: 30rem;
            height: 30rem;
            position: absolute;
            right: 10rem;
            top: 50rem;
        }
    }
</style>